export default __webpack_public_path__ + "static/media/template.00509c56.svg";